const actionTypes = {
    "STALEMATE": "STALEMATE",
    "GENERATE_CANDIDATE_MOVES": "GENERATE_CANDIDATE_MOVES",
    "NEW_MOVE": "NEW_MOVE",
    "NEW_GAME": "NEW_GAME",
    "INSUFFICIENT_MATERIAL": "INSUFFICIENT_MATERIAL",
    "REPETITION": "REPETITION",
    "FIFTY": "FIFTY",
    "WIN": "WIN",
    "CLEAR_CANDIDATE_MOVES": "CLEAR_CANDIDATE_MOVES",
    "PROMOTION_OPEN": "PROMOTION_OPEN",
    "POPUP_CLOSE": "POPUP_CLOSE",
    "TAKE_BACK": "TAKE_BACK",
    "FLIP": "FLIP"
}

export default actionTypes;